import { useState } from 'react';
import './BergCheckbox.scss';
interface IBergCheckbox {
  label?: React.ReactNode;
  name?: string;
  value?: string;
  onValueChange?: (value: boolean) => void;
}

const BergCheckbox = ({ label, name, onValueChange, value }: IBergCheckbox) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const handleChange = () => {
    setIsChecked(!isChecked);
    if (onValueChange) {
      onValueChange(!isChecked);
    }
  };
  return (
    <div className="berg-checkbox">
      <input
        type="checkbox"
        name={name}
        id={name}
        value={value}
        checked={isChecked}
        onChange={handleChange}
      />
      <label htmlFor={name}>{label}</label>
    </div>
  );
};

export default BergCheckbox;
